export default () => {
    document.querySelectorAll('.wysiwyg table').forEach((table) => {
        const tableWidth = table.clientWidth
        const tableBody = table.querySelector('tbody')
        if (tableBody && tableWidth > 0) {
            tableBody.style.width = `${tableWidth}px`
        }
        table.style.width = '100%'
    })
}
